var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "magnifying-glass",
    d: "M15,8.126A6.876,6.876,0,1,0,8.126,15,6.876,6.876,0,0,0,15,8.126ZM13.411,14.3a8.124,8.124,0,1,1,.887-.887l5.52,5.524a.624.624,0,0,1-.883.883Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifying-glass.d0085d669992878a92ec17d871a77ee0.svg";